export const ARRAYLAYER = 'ARRAYLAYER'